import { Box, HStack, VStack, Text, Button } from "@chakra-ui/react";
import { AlertTriangle, Clock } from "lucide-react";

const TOM_STYLES = {
  vermelho: { bg: "danger-subtle", border: "danger-subtle-border", icon: AlertTriangle, iconColor: "danger-text" },
  ambar: { bg: "warning-subtle", border: "warning-subtle-border", icon: Clock, iconColor: "warning-text" },
};

export default function AlertCard({ title, description, severity = "ambar", actionLabel, onAction }) {
  const style = TOM_STYLES[severity] ?? TOM_STYLES.ambar;
  const Icon = style.icon;

  return (
    <Box bg={style.bg} border="1px solid" borderColor={style.border} borderRadius="lg" p={3}>
      <HStack align="flex-start" spacing={3}>
        {/* Cor via CSS (currentColor): token semântico não resolve com useToken. */}
        <Box color={style.iconColor} flexShrink={0} mt="2px" lineHeight={0}>
          <Icon size={18} />
        </Box>
        <VStack align="flex-start" spacing={0.5} flex={1}>
          <Text fontSize="sm" fontWeight="semibold">
            {title}
          </Text>
          {description ? (
            <Text fontSize="xs" color="app-muted-fg">
              {description}
            </Text>
          ) : null}
        </VStack>
        {actionLabel ? (
          <Button size="sm" variant="ghost" onClick={onAction} flexShrink={0}>
            {actionLabel}
          </Button>
        ) : null}
      </HStack>
    </Box>
  );
}
